import { render, staticRenderFns } from "./menuDesktop.vue?vue&type=template&id=78641070&scoped=true"
import script from "./menuDesktop.vue?vue&type=script&lang=js"
export * from "./menuDesktop.vue?vue&type=script&lang=js"
import style0 from "./menuDesktop.vue?vue&type=style&index=0&id=78641070&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78641070",
  null
  
)

export default component.exports